import { settingsAPI } from "../../../apis/SettingsAPI.jsx";

export default class SettingsService {
  changePhone(token, state, setState, setMessages, getClientConfig) {
    settingsAPI
      .changePhone(token, state.countryCode + state.newPhoneNumber)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          getClientConfig();
          setState({
            loadingSent: false,
            stage: 2,
          });
        } else {
          //Failure
          setMessages("an-error-has-ocurred-during-phone-number-change");
          setState({
            invalidCountryCode: true,
            invalidNewPhoneNumber: true,
            loadingSent: false,
          });
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        setMessages("an-error-has-ocurred-during-phone-number-change");
        setState({
          invalidCountryCode: true,
          invalidNewPhoneNumber: true,
          loadingSent: false,
        });
      });
  }
}
